export const xpaLayoutContainerClassName = "xpaLayoutContainer";
